import React from "react";
import { Wrench, Settings, Package, ArrowRight } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { services } from "../data/mock";

const iconMap = {
  Wrench: Wrench,
  Settings: Settings,
  Package: Package
};

const serviceImages = [
  "/images/service-1.jpg",
  "/images/service-2.jpg",
  "/images/service-3.jpg",
];


export const Services = () => {
  return (
    <section id="leistungen" className="py-24 bg-neutral-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-accent font-semibold text-sm tracking-wider uppercase mb-4">
            Unsere Leistungen
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
            Leistungen
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Professionelle Reparatur und Aufbereitung für Ihre Gerüstbeläge
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group bg-white border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 overflow-hidden">

                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={serviceImages[index]}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

                  <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 rounded-xl bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-lg">
                      {IconComponent &&
                      <IconComponent className="w-6 h-6 text-primary" />
                      }
                    </div>
                  </div>
                </div>

                <CardContent className="p-6">
                  {/* Content */}
                  <h3 className="text-xl font-bold text-primary mb-3">
                    {service.title}
                  </h3>
                  <p className="text-secondary leading-relaxed mb-5 text-sm">
                    {service.description}
                  </p>

                  {/* Link */}
                  <button
                    onClick={() => {
                      const element = document.querySelector("#kontakt");
                      if (element) element.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="inline-flex items-center text-primary font-medium group-hover:text-accent transition-colors text-sm">

                    Anfrage stellen
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </button>
                </CardContent>

                {/* Bottom accent bar */}
                <div className="h-1 bg-gradient-to-r from-primary to-accent transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </Card>);

          })}
        </div>

        {/* B2B Note */}
        <p className="!text-sm !text-center mt-12 text-secondary">Angebot richtet sich an Gerüstbauer, Baufirmen und das Bau- & Baunebengewerbe.

        </p>
      </div>
    </section>);

};